import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    applications: [],
    combineApps: [],
    multiApps: [],
    multiCombinedApps: [],
    malwareApps: {},
    malwareSearchLoader: false
}

const name = 'applications'
const parentSelector = state => state?.[name]

const applicationsSlice = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        resetApplications: () => {
            return initialState;
        },
        setApplications: (state, action) => {
            return {
                ...state,
                applications: action.payload,
            };
        },
        setCombineApps: (state, action) => {
            return {
                ...state,
                combineApps: action.payload,
            };
        },
        setMultiApps: (state, action) => {
            return {
                ...state,
                multiApps: action.payload,
            };
        },
        setMultiCombinedApps: (state, action) => {
            return {
                ...state,
                multiCombinedApps: action.payload,
            };
        },
        setMalwareApps: (state, action) => {
            return {
                ...state,
                malwareApps: action.payload,
            };
        },
        setMalwareSearchLoader: (state, action) => {
            return {
                ...state,
                malwareSearchLoader: action.payload,
            };
        },

    },
});


const getApplications = createSelector(parentSelector, state => {
    return state?.applications
})
const getCombineApps = createSelector(parentSelector, state => {
    return state?.combineApps
})

const getMultiApps = createSelector(parentSelector, state => {
    return state?.multiApps
})
const getMultiCombinedApps = createSelector(parentSelector, state => {
    return state?.multiCombinedApps
});

const getMalwareApps = createSelector(parentSelector, state => {
    return state?.malwareApps
});

const getMalwareSearchLoader = createSelector(parentSelector, state => {
    return state?.malwareSearchLoader
})

const actions = {
    ...applicationsSlice.actions
}

const selectors = {
    getApplications,
    getCombineApps,
    getMultiApps,
    getMultiCombinedApps,
    getMalwareApps,
    getMalwareSearchLoader
}

export const applicationsActions = { actions, selectors }


export default applicationsSlice;